module.exports = __webpack_public_path__ + "static/fulfillment-centers-vs-warehouse-hero-bg-4b36e34c6cba7cdafb49a9fd36dc7154.png";